import { render, staticRenderFns } from "./OfferItemsTable.vue?vue&type=template&id=2114baac&scoped=true"
import script from "./OfferItemsTable.vue?vue&type=script&lang=ts"
export * from "./OfferItemsTable.vue?vue&type=script&lang=ts"
import style0 from "./OfferItemsTable.vue?vue&type=style&index=0&id=2114baac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2114baac",
  null
  
)

export default component.exports